import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';

function Forgot() {
  const rawBaseUrl = process.env.REACT_APP_BASE_API_URL || 'https://api.marclife.io/api/admin';
  const baseurl = rawBaseUrl.trim();
  const navigate = useNavigate();

  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSendOtp = async (e) => {
    e.preventDefault();
    setError('');

    if (!email.trim()) {
      toast.warn('Please enter your registered email address.');
      return;
    }

    setLoading(true);

    try {
      const response = await fetch(`${baseurl}/forgot-password`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        body: JSON.stringify({ email: email.trim() }),
      });

      const data = await response.json();

      if (response.ok && data.status) {
        toast.success(data.message || 'OTP sent successfully to your email!');
        sessionStorage.setItem('resetEmail', email.trim());
        if (data.otp) {
          sessionStorage.setItem('demoOtp', data.otp);
        }
        // Redirect to Reset Password screen after brief delay
        setTimeout(() => {
          navigate('/reset', { state: { email: email.trim() } });
        }, 1200);
      } else {
        const msg = data.message || 'Failed to send reset code. Please check your email.';
        setError(msg);
        toast.error(msg);
      }
    } catch (err) {
      console.error('Forgot password error:', err);
      const msg = 'Network error. Please try again.';
      setError(msg);
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <ToastContainer position="top-right" autoClose={3000} />
      <div className="container-fluid custom-page">
        <div className="row bg-white">
          {/* The image half */}
          <div className="col-md-6 col-lg-6 col-xl-7 d-none d-md-flex bg-primary-transparent-3">
            <div className="row w-100 mx-auto text-center">
              <div className="col-md-12 col-lg-12 col-xl-12 my-auto mx-auto w-100">
                <img
                  src="assets/images/backgroud/loginImage.png"
                  className="my-auto ht-xl-80p wd-md-100p wd-xl-80p mx-auto"
                  alt="logo"
                />
              </div>
            </div>
          </div>

          {/* The content half */}
          <div className="col-md-6 col-lg-6 col-xl-5 bg-white py-4">
            <div className="login d-flex align-items-center py-2">
              <div className="container p-0">
                <div className="row">
                  <div className="col-md-10 col-lg-10 col-xl-9 mx-auto">
                    <div className="card-sigin">
                      <div className="mb-4 d-flex">
                        <Link to="/" className="header-logo">
                          <img
                            src="assets/images/logo/walletIcon.png"
                            style={{ height: '40px' }}
                            alt="logo"
                          />
                        </Link>
                      </div>

                      <div className="main-signup-header">
                        <h3 className="fw-bold text-dark">Forgot Password?</h3>
                        <p className="text-muted mb-4 fs-14">
                          Enter your registered administrator or sub-admin email address. We'll send an OTP verification code to reset your password.
                        </p>

                        {error && (
                          <div className="alert alert-danger py-2 fs-13 mb-3">
                            <i className="fa fa-exclamation-circle me-1"></i> {error}
                          </div>
                        )}

                        <form onSubmit={handleSendOtp}>
                          <div className="form-group mb-3">
                            <label className="form-label fw-semibold text-dark">Admin Email Address</label>
                            <div className="input-group">
                              <span className="input-group-text bg-light text-muted">
                                <i className="fa fa-envelope"></i>
                              </span>
                              <input
                                className="form-control"
                                placeholder="name@domain.com"
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                                autoFocus
                              />
                            </div>
                          </div>

                          <button
                            type="submit"
                            className="btn btn-primary btn-block w-100 py-2 fw-semibold d-flex align-items-center justify-content-center gap-2"
                            disabled={loading}
                          >
                            {loading ? (
                              <>
                                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                Sending OTP Code...
                              </>
                            ) : (
                              <>
                                <i className="fa fa-paper-plane"></i> Send Verification Code
                              </>
                            )}
                          </button>
                        </form>

                        <div className="main-signin-footer mt-4 pt-2 border-top text-center">
                          <p className="text-muted mb-0 fs-13">
                            Remember your password?{' '}
                            <Link to="/login" className="text-primary fw-bold">
                              Back to Sign In
                            </Link>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Forgot;